import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgAyandeh = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#ayandeh_svg__a)'>
      <path
        fill='#CF9D2A'
        d='M2.218-.002h19.498c.336.156.675.308 1.003.49.53.3.89.831 1.101 1.39.24.636.167 1.327.177 1.991v17.232c0 1.024-.502 2.123-1.475 2.565-.683.357-1.473.282-2.217.287q-7.587-.007-15.173 0c-1.02.013-2.05.125-3.061-.063C.903 23.58-.032 22.457.008 21.233c-.011-6.12 0-12.247-.006-18.37a2.54 2.54 0 0 1 .447-1.538C.877.701 1.554.318 2.224 0zm-.15 1.064C1.178 1.515.638 2.505.663 3.49c.01 3.166 0 6.334 0 9.501.338-.46.58-.976.877-1.46.676-1.08 1.466-2.107 2.477-2.898 1.323-1.075 3.104-1.61 4.8-1.306 1.362.338 2.591 1.036 3.833 1.66 1.704.907 3.385 1.889 5.197 2.56 1.027.328 2.177.635 3.226.217.947-.351 1.53-1.278 1.805-2.204.215-.797.413-1.611.403-2.443V3.236c.01-1.296-1.167-2.477-2.473-2.465q-8.343.012-16.687 0c-.69.009-1.438-.087-2.06.285zm20.158 11.835c-.752 1.175-1.713 2.238-2.905 2.979-1.227.736-2.721 1.095-4.138.826-1.53-.355-2.896-1.154-4.283-1.855-1.937-1.013-3.857-2.17-6.019-2.615-1.03-.236-2.24-.019-2.953.806-.831.917-1.025 2.197-1.231 3.372-.07 1.355 0 2.713-.034 4.07a2.7 2.7 0 0 0 .382 1.506c.273.453.672.818 1.15 1.048.6.299 1.288.21 1.935.218h15.8c.557-.01 1.129.048 1.67-.133 1.018-.374 1.756-1.428 1.694-2.515-.015-3.13.02-6.26-.018-9.391-.396.53-.66 1.145-1.04 1.686z'
      />
      <path
        fill='#522D1D'
        d='M2.062 1.06C2.69.687 3.432.786 4.122.777H20.81c1.305-.013 2.482 1.169 2.472 2.465s0 2.589 0 3.882c.01.832-.188 1.646-.402 2.443-.275.926-.86 1.853-1.806 2.204-1.048.418-2.198.11-3.225-.218-1.817-.67-3.494-1.652-5.198-2.558-1.242-.625-2.473-1.324-3.835-1.664-1.695-.304-3.476.231-4.799 1.307-1.01.79-1.8 1.818-2.477 2.897-.298.484-.54.999-.877 1.46v-9.5c-.024-.986.515-1.976 1.405-2.43zm20.172 11.846c.376-.54.645-1.155 1.04-1.686.04 3.13 0 6.261.018 9.392.063 1.086-.676 2.145-1.693 2.515-.538.18-1.113.125-1.67.132H4.13c-.647-.007-1.336.081-1.935-.217a2.701 2.701 0 0 1-1.532-2.554c.03-1.357-.037-2.716.033-4.07.207-1.173.4-2.453 1.232-3.372.713-.825 1.923-1.043 2.953-.807 2.168.446 4.088 1.602 6.02 2.615 1.386.702 2.758 1.499 4.281 1.856 1.42.268 2.915-.09 4.139-.827 1.192-.74 2.155-1.803 2.905-2.978'
      />
    </g>
    <defs>
      <clipPath id='ayandeh_svg__a'>
        <path fill='#fff' d='M0-.002h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgAyandeh)
export default ForwardRef
